<template>
  <div class="title">
    <h2>{{ $t('headerTitle') }}</h2>
  </div>
  <div class="app-container">
    <div class="download-map">
      <h3 class="download-title">{{ $t('downloadTitle') }}</h3>
      <div class="change-language">
        <el-select v-model="selectedLanguage" @change="changeLanguage">
          <el-option :label="$t('language.english')" value="en"></el-option>
          <el-option :label="$t('language.chinese')" value="zh"></el-option>
        </el-select>
      </div>
    </div>
    <div class="title-box">
      <div class="title-box-img">
        <img src="../../images/bulb.png" alt="bulb" />
      </div>
      <div class="title-box-text">
        {{ $t('bicyclecomputer.installationInstructions') }}
        <a class="title-button" @click="illustrateOpen = true">
          {{ $t('bicyclecomputer.instructions') }}
        </a>
      </div>
    </div>

    <div class="map-table" v-loading="loading">
      <el-tabs
        type="card"
        class="tabs-table"
      >
        <el-tab-pane
          v-for="item in uniqueTableData"
          :key="item.id"
          :label="tabLabel(item)"
        >
          <el-table :data="filteredTableData(item.continent)" row-key="id" height="calc(100vh - 320px)" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column :prop="dynamicCountryProp" :label="$t('bicyclecomputer.country')"></el-table-column>
            <el-table-column prop="state" :label="$t('bicyclecomputer.state')"></el-table-column>
            <el-table-column prop="version" width="80" :label="$t('bicyclecomputer.version')">
              <template #default="scope">
                v{{scope.row.version}}
              </template>
            </el-table-column>
            <el-table-column prop="size" width="280" align="center" :label="$t('bicyclecomputer.packageSize')">
              <template #default="scope">
                {{(scope.row.packageSize/1024/1024).toFixed(2)}} M（{{(scope.row.unzipPackageSize/1024/1024).toFixed(2)}}M）
              </template>
            </el-table-column>
            <el-table-column prop="utime" :label="$t('bicyclecomputer.updateTime')"></el-table-column>
            <el-table-column :label="$t('bicyclecomputer.operation')" width="250" align="center">
              <template #default="scope">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadUrl(scope.row)"
                >
                {{ $t('bicyclecomputer.copyLink') }}
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(scope.row)"
                  >{{ $t('bicyclecomputer.downloadBtn') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>

        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="select-download-button-wrapper">
      <el-button class="select-download-button" @click="downLoadAll" v-if="multipleSelection.length>0">下载选择项 {{ multipleSelection.length }} 条</el-button>
    </div> -->
  </div>

  <!-- 安装说明弹窗-->
  <el-dialog v-model="illustrateOpen" width="1050px" append-to-body lock-scroll>
    <div class="content">
      <div class="content-title">
        <h2 style="text-align: center">{{ $t('installationInstructions.headerTitle') }}</h2>
      </div>
      <div class="content-text">
        <h4>{{ $t('installationInstructions.downloadTitle') }}</h4>
        <p class="">{{ $t('installationInstructions.intr1') }}<a href="https://map.sports.mentech.com/bicyclecomputer">https://map.sports.mentech.com/bicyclecomputer</a>
          {{ $t('installationInstructions.intr2') }}</p>
        <h4>{{ $t('installationInstructions.intrTitle') }}</h4>
        <p>{{ $t('installationInstructions.intrPart1') }}</p>
        <img :src="installImages.img1" alt="illustrate_1" />
        <p>{{ $t('installationInstructions.intrPart2') }}</p>
        <img :src="installImages.img2" alt="illustrate_2" />
        <p>{{ $t('installationInstructions.intrPart3') }}</p>
        <img :src="installImages.img3" alt="illustrate_3" />
        <p>{{ $t('installationInstructions.intrPart4') }}</p>
        <img :src="installImages.img4" alt="illustrate_4" />

        <div class="content-feater-box">
          <div class="content-feater-text">
            <h4>{{ $t('installationInstructions.note') }}</h4>
            <p>
              {{ $t('installationInstructions.noteContent') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { request } from '../../utils/request.js';
import { areaTranslations } from '../../constants/dictionary.js';
import { ElMessage } from "element-plus";
import { ref, computed } from "vue";
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const illustrateOpen = ref(false);

const tableData = ref([]);
const params = ref({
  page: 1,
  pageSize: 1000,
});
const downloadUrl = ref('');

const selectedLanguage = ref(locale.value); // 语言选择绑定
const loading = ref(false);

const changeLanguage = () => {
  locale.value = selectedLanguage.value; // 切换语言
  // 更新缓存国家代码
  localStorage.setItem('userCountryCode', selectedLanguage.value);
  console.log('切换语言为：', localStorage.getItem('userCountryCode'));
};

/**
 *
 * 获取列表
 *
 */
function getList() {
  loading.value = true;
  request({
    url: '/mapinfo/map/getAllMapResource',
    method: 'get',
    params: params.value
  })
  .then((response) => {
    // 过滤掉 downloadUrl 中包含 '-cm' 的数据项，即不展示等高线地图
    tableData.value = response.data.filter(item => !item.downloadUrl?.includes('-cm'));
  })
  .catch((error) => {
    console.error('Error fetching data:', error);
    ElMessage({
      message: 'Failed to fetch data',
      type: 'error',
    });
  })
  .finally(() => {
    loading.value = false;
  });
}

/**
 *
 * 去重处理
 *
 */
const uniqueTableData = computed(() => {
  const seen = new Set();
  return tableData.value.filter(item => {
    if (seen.has(item.continent)) {
      return false;
    } else {
      seen.add(item.continent);
      return true;
    }
  });
});

/**
 *
 * 根据语言切换标签
 *
 */
 const tabLabel = (item) => {
  // 如果当前语言是英文，直接返回item.continent，英文首字母大写
  if (locale.value === 'en') {
    return item.continent.charAt(0).toUpperCase() + item.continent.slice(1).toLowerCase();
  } else {
    // 从areaTranslations映射中获取item.continent对应的中文名称
    const chineseTranslation = areaTranslations.get(item.continent.toLowerCase());
    // 如果找到了对应的中文名称，返回该名称；否则返回默认值或进行错误处理
    return chineseTranslation ? chineseTranslation : item.continent;
  }
};

/**
 * 根据 continent 过滤数据
 */
 const filteredTableData = (continent) => {
  return tableData.value.filter(item => item.continent === continent);
};


/**
 * 动态决定 country 列的 prop
 */
 const dynamicCountryProp = computed(() => {
  return locale.value === 'zh' ? 'countryCN' : 'country';
});

/**
 *
 * 获取下载链接
 *
 */
 function getDownloadLink(row) {
  return new Promise((resolve, reject) => {
    if (!row?.downloadUrl) {
      reject(new Error(t('dialog.emptyLinkError')));
      return;
    }

    request({
      url: '/mapinfo/map/getMapPackageUrl',
      method: 'get',
      params: { url: row.downloadUrl }
    })
    .then(response => {
      if (response?.data?.urlAddress) {
        downloadUrl.value = response.data.urlAddress;
        resolve(downloadUrl.value);
      } else {
        reject(new Error(t('dialog.invalidResponseError')));
      }
    })
    .catch(error => {
      console.error('Error fetching download link:', error);
      reject(new Error(t('dialog.fetchLinkError')));
    });
  });
}

 
/**
 * 复制下载链接
 */
 async function copyDownloadUrl(row) {
  try {
    const url = await getDownloadLink(row);
    
    if (!url) {
      throw new Error(t('dialog.emptyLinkError'));
    }

    await navigator.clipboard.writeText(url);
    
    ElMessage({
      message: t('dialog.copySuccess'),
      type: 'success',
      grouping: true
    });
  } catch (error) {
    ElMessage({
      message: error.message || t('dialog.copyError'),
      type: 'error'
    });
  }
}

/**
 * 直接下载地图文件
 */
async function handleDowload(row) {
  try {
    // 等待获取下载链接
    await getDownloadLink(row);

    if (downloadUrl.value) {
      const link = document.createElement("a");
      link.href = downloadUrl.value;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      ElMessage({
        message: "获取下载链接失败，请重试",
        type: "error",
      });
    }
  } catch (error) {
    console.error("下载失败:", error);
    ElMessage({
      message: "下载失败，请重试",
      type: "error",
    });
  }
}

getList();

// 安装说明图片
const installImages = computed(() => ({
  img1: require(`../../images/${locale.value === 'zh' ? 'install1-1.png' : 'install2-1.png'}`),
  img2: require(`../../images/${locale.value === 'zh' ? 'install1-2.png' : 'install2-2.png'}`),
  img3: require(`../../images/${locale.value === 'zh' ? 'install1-3.png' : 'install2-3.png'}`),
  img4: require(`../../images/${locale.value === 'zh' ? 'install1-4.png' : 'install2-4.png'}`)
}));

</script>

<style scoped>
a {
  text-decoration: none;
  color: #3070ff;
}

.app-container {
  width: 1250px;
  margin: 0 auto;
  padding-top: 15px;
}

.title-box {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px 10px 14px 0;
  background-color: #f1f4fa;
  border-radius: 10px;
  margin: 15px 0;
  display: flex;
}

.title-box .title-box-text .title-button {
  background: none; /* 清除背景 */
  color: #3070ff; /* 文字颜色继承父元素 */
  border: none; /* 清除边框 */
  padding: 0; /* 清除内边距 */
  margin: 0; /* 清除外边距 */
  font: inherit; /* 字体样式继承父元素 */
  cursor: pointer; /* 鼠标样式为指针 */
}

.title-box .title-box-img img {
  width: 20px;
  height: 20px;
  margin-left: 20px;
}

.title-box .title-box-text {
  margin-left: 15px;
  line-height: 24px;
}

.content {
  width: 100%;
  height: 900px;
  color: #000;
}

.content-title {
  height: 5%;
}

.content-text {
  height: 95%;
  overflow: auto;
  font-size: 18px;
  padding: 0 20px;
}

.content-text p {
  margin-bottom: 15px;
}

.content img {
  width: 100%;
  margin-bottom: 30px;
}

.content-feater-box {
  width: 100%;
  height: 110px;
  background-color: #f1f4fa;
  border-radius: 10px;
}

.content-feater-text {
  padding: 15px;
}

.map-table {
  margin-bottom: 20px;
}
.select-download-button-wrapper {
  position: fixed;
  bottom: 20px;
  z-index: 10;
  background-color: #fff;
}
::v-deep .el-tabs__item {
  width: 200px;
}
</style>